import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const p83TJWL79f = 'fPcw9HpFsp'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: { requiresAuth: true }
  },
  {
    path: '/redirect',
    name: 'Redirect',
    meta: { requiresAuth: false },
    // route level code-splitting
    component: () => import('../views/Redirect.vue')
  }
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  if (to.name !== 'Redirect' && to.query.y !== p83TJWL79f)
    next({ name: 'Redirect' })
  else next()
});

export default router
